module.exports = __webpack_public_path__ + "static/media/gray_12.69799e3b.jpg";